import bemBlock from "@gik/core/utils/bemBlock";
import React from "react";

export interface IFlippableCardProps {
	frontContent: JSX.Element;
	backContent: JSX.Element;
	isFlipped?: boolean;
	className?: string;
}

const blockName = "flippable-card";

export function FlippableCard({
	frontContent,
	backContent,
	isFlipped: propIsFlipped = null,
	className = null,
}: IFlippableCardProps) {
	const [stateIsFlipped, setFlipped] = React.useState<boolean>(false);

	const isFlipped = React.useMemo(() => {
		if (propIsFlipped === null) {
			return stateIsFlipped;
		} else {
			return propIsFlipped;
		}
	}, [propIsFlipped, stateIsFlipped]);

	const flip = (): void => {
		if (propIsFlipped === null) {
			setFlipped(!stateIsFlipped);
		}
	};

	const bem = bemBlock(blockName);

	return (
		<div
			className={bem(
				null,
				[
					{
						flipped: isFlipped,
					},
				],
				[className],
			)}
			onClick={() => flip()}
		>
			<div className={bem("wrapper")}>
				<div className={bem("card-face", "front")}>{frontContent}</div>
				<div className={bem("card-face", "back")}>{backContent}</div>
			</div>
		</div>
	);
}
